import {
  Box,
  Flex,
  Image,
  Text,
  SimpleGrid,
  GridItem,
  Heading,
  HStack,
  Icon,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";

import { Button } from "../components/ui/button";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Partners } from "../components/Partners";
import { GetStarted } from "../components/GetStarted";

import Person1 from "../assets/images/person1.png";
import Person2 from "../assets/images/person2.png";
import Person3 from "../assets/images/person3.png";
import Person4 from "../assets/images/person4.png";
import HeroImage from "../assets/images/heroImage.png";
import Triangles from "../assets/images/triangles.png";
import GroupImage from "../assets/images/groupImage.png";
import GroupImage2 from "../assets/images/groupImage2.png";
import Angled from "../assets/images/angled.png";
import Quotes from "../assets/images/quotes.png";
import Person5 from "../assets/images/person5.png";

const imageStyle = { width: "24px", height: "24px", borderRadius: "12px" };

export const Home = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Header />

      <Box bg={"#0D1E21"}>
        <Flex
          px={{ base: "16px", md: "70px" }}
          pt="47px"
          pb="20px"
          justifySelf={"center"}
          w={{ base: "100%", md: "70%" }}
          flexDir={"column"}
        >
          <Flex gap={"6px"} justify={"center"}>
            <HStack gap={0} position="relative">
              <Image src={Person1} style={imageStyle} zIndex={1} />
              <Image src={Person2} style={imageStyle} zIndex={2} ml="-4px" />
              <Image src={Person3} style={imageStyle} zIndex={3} ml="-4px" />
              <Image src={Person4} style={imageStyle} zIndex={4} ml="-4px" />
            </HStack>

            <Flex
              fontSize={{ base: "14px", md: "18px" }}
              gap={1}
              fontFamily={"Sora-Regular"}
            >
              <Text color="rgba(243, 244, 246, 0.7)">Trusted by over</Text>

              <Text color="white" fontWeight={500}>
                100+ companies
              </Text>
            </Flex>
          </Flex>

          <Heading
            mt="16px"
            fontSize={{ base: "28px", md: "50px" }}
            fontWeight={500}
            color={"white"}
            textAlign={"center"}
            lineHeight={"130%"}
            fontFamily={"DMSans-Medium"}
          >
            Connecting Research with Social Impact Investments
          </Heading>

          <Text
            my="16px"
            fontSize={{ base: "16px", md: "23px" }}
            color={"#EBF0F0"}
            textAlign={"center"}
            fontFamily={"DMSans-Medium"}
            fontWeight={400}
          >
            Bridging academia, multinationals, and community organizations
            through a structured, research-driven approach
          </Text>

          <Flex justify={"center"} gap={"16px"}>
            <Button
              onClick={() => navigate("/contact")}
              display={{ base: "block", md: "none" }}
            >
              Get Started
            </Button>

            <Button opaque={false} onClick={() => navigate("/approach")}>
              Our Approach
            </Button>
          </Flex>
        </Flex>

        <Image
          src={HeroImage}
          h={{ base: "250px", md: "auto" }}
          w={"100%"}
          // maxW={{ base: "100%", "2xl": "1300px" }}
          // mx="auto"
          objectFit={"cover"}
        />
      </Box>

      <Partners />

      <Box
        bg="white"
        py={{ base: "64px", md: "107px" }}
        px={{ base: "16px", md: "70px", "2xl": 0 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <Flex
          gap={{ base: "24px", md: "70px" }}
          mb={{ base: "32px", md: "111px" }}
          flexDir={{ base: "column", md: "row" }}
        >
          <Text
            fontSize={{ base: "14px", md: "19px" }}
            color={"black"}
            textDecoration={"underline"}
            whiteSpace={"nowrap"}
            fontFamily={"Sora-Regular"}
          >
            OUR VISION
          </Text>

          <Heading
            fontSize={{ base: "23px", md: "48px" }}
            color={"#203F3D"}
            lineHeight={"140%"}
            fontWeight={500}
            fontFamily={"DMSans-Medium"}
          >
            To catalyze change by bridging research and social impact
            investments across sectors.
          </Heading>

          <Flex flexDir={"column"}>
            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              fontFamily={"Sora-Regular"}
            >
              Driving meaningful change by transforming research insights into
              impactful investments across industries. Driving meaningful change
              by transforming research insights into impactful investments
              across industries.
            </Text>

            <Button
              alignSelf={{ base: "flex-start", md: "flex-end" }}
              mt={{ base: "24px", md: "30px" }}
            >
              See More
            </Button>
          </Flex>
        </Flex>

        <Flex
          gap={{ base: "24px", md: "70px" }}
          flexDir={{ base: "column", md: "row" }}
        >
          <Text
            fontSize={{ base: "14px", md: "19px" }}
            color={"black"}
            textDecoration={"underline"}
            whiteSpace={"nowrap"}
            fontFamily={"Sora-Regular"}
          >
            OUR MISSION
          </Text>

          <Heading
            fontSize={{ base: "23px", md: "48px" }}
            color={"#203F3D"}
            lineHeight={"140%"}
            fontWeight={500}
            fontFamily={"DMSans-Medium"}
          >
            Empowering Communities Through Collaboration and Sustainability.
          </Heading>

          <Flex flexDir={"column"}>
            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              fontFamily={"Sora-Regular"}
            >
              We unite academic insights, corporate social responsibility, and
              community needs to empower local organizations, drive sustainable
              projects, and create lasting social impact.
            </Text>

            <Button
              alignSelf={{ base: "flex-start", md: "flex-end" }}
              mt={{ base: "24px", md: "30px" }}
            >
              See More
            </Button>
          </Flex>
        </Flex>
      </Box>

      <Box
        bg="white"
        borderTopWidth={{ base: "1px", "2xl": 0 }}
        borderBottomWidth={{ base: "1px", "2xl": 0 }}
        borderColor={"#E7E8E9"}
        px={{ base: "16px", md: "70px", "2xl": 0 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
        py={{ base: "64px", md: "88.5px" }}
      >
        <Heading
          textAlign={"center"}
          fontSize={{ base: "28px", md: "48px" }}
          fontWeight={500}
          lineHeight={"140%"}
          color={"#434E61"}
          fontFamily={"DMSans-Medium"}
        >
          Our Services
        </Heading>

        <SimpleGrid
          mt={{ base: "32px", md: "48px" }}
          columns={{ base: 1, md: 3 }}
          gap={{ base: "16px", md: "26px" }}
        >
          <GridItem colSpan={1} h="468px">
            <Flex
              bg="#0D1E21"
              h={"100%"}
              px={{ base: "19px", md: "26px" }}
              py={{ base: "31px", md: "43px" }}
              flexDir={"column"}
              justifyContent={"space-between"}
            >
              <Text
                fontSize={{ base: "28px", md: "40px" }}
                fontWeight={500}
                color={"#F8F9FA"}
                fontFamily={"DMSans-Medium"}
              >
                Capacity Building & Training
              </Text>

              <Flex align={"flex-end"} justify={"space-between"}>
                <Button>Learn More</Button>

                <Image src={Triangles} w={"100px"} />
              </Flex>
            </Flex>
          </GridItem>

          <GridItem colSpan={{ base: 1, md: 2 }} h="468px">
            <Flex
              flexDir={{ base: "column", md: "row" }}
              h={"100%"}
              backgroundSize={"cover"}
              backgroundPosition={"center"}
              bgRepeat={"no-repeat"}
              px={{ base: "19px", md: "26px" }}
              py={{ base: "31px", md: "43px" }}
              justifyContent={"space-between"}
              align={{ base: "flex-start", md: "flex-end" }}
              backgroundImage={`url(${GroupImage})`}
              position="relative"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "#0C1D18",
                opacity: 0.5,
                zIndex: 0,
              }}
            >
              <Heading
                fontSize={{ base: "28px", md: "40px" }}
                fontWeight={500}
                color={"#F8F9FA"}
                lineHeight={"140%"}
                w={{ base: "100%", md: "75%" }}
                position="relative"
                zIndex={1}
                fontFamily={"DMSans-Medium"}
              >
                Research & Partnership Development
              </Heading>

              <Button position="relative" zIndex={1}>
                Learn More
              </Button>
            </Flex>
          </GridItem>

          <GridItem colSpan={{ base: 1, md: 2 }} h="468px">
            <Flex
              flexDir={{ base: "column", md: "row" }}
              h={"100%"}
              backgroundSize={"cover"}
              backgroundPosition={"center"}
              bgRepeat={"no-repeat"}
              px={{ base: "19px", md: "26px" }}
              py={{ base: "31px", md: "43px" }}
              justifyContent={"space-between"}
              align={{ base: "flex-start", md: "flex-end" }}
              backgroundImage={`url(${GroupImage2})`}
              position="relative"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "#0C1D18",
                opacity: 0.5,
                zIndex: 0,
              }}
            >
              <Heading
                fontSize={{ base: "28px", md: "40px" }}
                fontWeight={500}
                color={"#F8F9FA"}
                lineHeight={"140%"}
                w={{ base: "100%", md: "75%" }}
                position="relative"
                zIndex={1}
                fontFamily={"DMSans-Medium"}
              >
                Research & Investment Alignment
              </Heading>

              <Button position="relative" zIndex={1}>
                Learn More
              </Button>
            </Flex>
          </GridItem>

          <GridItem colSpan={1} h="468px">
            <Flex
              bg="#EBF0F0"
              h={"100%"}
              pl="26px"
              pt="43px"
              flexDir={"column"}
              justifyContent={"space-between"}
            >
              <Text
                fontSize={{ base: "28px", md: "40px" }}
                fontWeight={500}
                color={"#0D1E21"}
                pr={"23px"}
                fontFamily={"DMSans-Medium"}
              >
                Scaling & Sustainability
              </Text>

              <Flex align={"flex-end"} justify={"space-between"}>
                <Button mb="43px">Learn More</Button>

                <Image src={Angled} w={"125px"} />
              </Flex>
            </Flex>
          </GridItem>
        </SimpleGrid>
      </Box>

      <Box bg="#F5F5F5" maxW={{ base: "100%", "2xl": "1300px" }} mx="auto">
        <SimpleGrid columns={{ base: 1, md: 2 }}>
          <GridItem
            bg="white"
            px={{ base: "16px", md: "70px", "2xl": 0 }}
            py={{ base: "64px", md: "165px" }}
          >
            <Text
              fontSize={{ base: "31px", md: "48px" }}
              color={"#101720"}
              lineHeight={"140%"}
              w={{ base: "100%", md: "50%", "2xl": "70%" }}
              fontFamily={"DMSans-Medium"}
            >
              Our Clients, Love us.
            </Text>

            <Text
              fontSize={{ base: "17px", md: "19px" }}
              color={"#203F3D"}
              mt={{ base: "8px", md: "0px" }}
            >
              Don't just take our word for it, hear what our community has to
              say
            </Text>

            <Button mt="38px" onClick={() => navigate("/contact")}>
              Get Started
            </Button>
          </GridItem>

          <GridItem
            bg="#F4F8F8"
            pr={{ base: "30px", md: "70px" }}
            pl={{ base: "30px", md: "70px" }}
            py={{ base: "50px", md: "165px" }}
          >
            <Flex
              bg="white"
              borderWidth={"1px"}
              borderColor={"#ECECEC"}
              borderRadius={"10px"}
              px="31px"
              py="40px"
              flexDir={"column"}
              gap={"24px"}
            >
              <Image src={Quotes} w={"32px"} />

              <Text fontSize={"16px"} color={"#667085"}>
                Partnering with this consulting team has transformed our
                business, helping us overcome challenges and drive real growth.
              </Text>

              <Box h={"1px"} bg="#E7E8E9" />

              <Flex gap={"13px"} align={"center"}>
                <Image src={Person5} w={"42px"} />

                <Flex flexDir={"column"}>
                  <Text fontSize={"19px"} fontWeight={500} color={"#101720"}>
                    Toveyah Johnson
                  </Text>

                  <Text fontSize={"13px"} color={"#667085"}>
                    Manager
                  </Text>
                </Flex>
              </Flex>
            </Flex>

            <Flex mt="35px" justify={"space-between"}>
              <Flex
                align={"center"}
                justify={"center"}
                borderWidth={"1px"}
                borderColor={"#346864"}
                bg="white"
                w={"44px"}
                h={"44px"}
                borderRadius={"full"}
              >
                <Icon size={"md"} color={"#346864"}>
                  <FaArrowLeft />
                </Icon>
              </Flex>

              <Flex
                align={"center"}
                justify={"center"}
                borderWidth={"1px"}
                borderColor={"#346864"}
                bg="white"
                w={"44px"}
                h={"44px"}
                borderRadius={"full"}
              >
                <Icon size={"md"} color={"#346864"}>
                  <FaArrowRight />
                </Icon>
              </Flex>
            </Flex>
          </GridItem>
        </SimpleGrid>
      </Box>

      <GetStarted />

      <Footer />
    </Box>
  );
};
